// Phase 15.1 — Optimisation Campaigns API client.
// Thin axios wrappers; mirrors ``api/pkCampaigns.js``.
import { api as client } from "@/api/client";

const BASE = "/api/optimisation-campaigns";

export const optimisationCampaigns = {
    create: (body) => client.post(BASE, body).then((r) => r.data),
    list: (params = {}) => client.get(BASE, { params }).then((r) => r.data),
    get: (id) => client.get(`${BASE}/${id}`).then((r) => r.data),
    cancel: (id) => client.post(`${BASE}/${id}/cancel`).then((r) => r.data),
    remove: (id) => client.delete(`${BASE}/${id}`).then((r) => r.status),
    registry: () => client.get(`${BASE}/registry`).then((r) => r.data),
};

export default optimisationCampaigns;
